import { render, staticRenderFns } from "./SubmissionsTableRow.vue?vue&type=template&id=9bc836c8&scoped=true&"
import script from "./SubmissionsTableRow.vue?vue&type=script&lang=js&"
export * from "./SubmissionsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsTableRow.vue?vue&type=style&index=0&id=9bc836c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc836c8",
  null
  
)

export default component.exports